<template>
  <div class="home contenido">
    <div class="container">
        <HelloWorld 
            msg="Administración de riesgos"
            idea="La gestión de riesgos ofrece planes que le dan certeza y continuidad a tu operación, ayudando a prevenir y reducir las situaciones que pueden salirse de control."
            :imagen="imagen"
         />
         <Titulo titulo="¿Cómo lo hacemos?" />
         <div class="espacio mt-5"></div>
         <Fototextosombra titulo="Certidumbre ante cualquier amenaza" texto="Basados en una metodología avalada por estándares e institutos internacionales, revisamos los factores que ponen en peligro el desempeño de las empresas, bajo el siguiente esquema:<ul class='mt-4'><li>Identificamos las exposiciones al riesgo: humanas, físicas, contractuales, del entorno.</li><li class='mt-3'>Analizamos las causas principales de pérdidas económicas.</li></ul>" :imagen="imagen2" pos="fotoderecha" />
         <Fototextosombra texto="<ul>
         <li class='mb-3'>Implementamos medidas de control que mitiguen los efectos del riesgo, así como la planificación, el adecuado manejo de la crisis y desastres de cara a una eventualidad.</li>
         <li class='mb-3'>Estudiamos los aspectos financieros: análisis cuantitativo, herramientas, métodos de financiamiento interno y externo.</li>
         </ul><p>A través de estos procesos buscamos darte certeza, enfocarte en la prevención con un programa que vaya a la raíz de las variables y te ayude a minimizar las pérdidas.</p>" :imagen="imagen3" pos="fotoizquierda" />
         <Titulo2 titulo="¿Tu organización está preparada?" />
    </div>
    <div class="triangulo"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/banner-header-new_02-administracion-de-riesgos.jpg'
import Imagen2 from '@/assets/images/pageinteriors_02administracion-de-riesgos-01.jpg'
import Imagen3 from '@/assets/images/pageinteriors_02administracion-de-riesgos-02.jpg'
import Titulo from '@/components/Titulo.vue'
import Titulo2 from '@/components/Titulo2.vue'
import Fototextosombra from '@/components/Fototextosombra.vue'
export default {
  name: 'Nosotros',
  data() {
      return {
          imagen: Imagen,
          imagen2: Imagen2,
          imagen3: Imagen3,
      }
  },
  components: {
    HelloWorld,
    Titulo,
    Titulo2,
    Fototextosombra,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      muestraFooter: function(){
          this.$store.commit('muestraFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.muestraFooter();
      this.$store.commit('mideMenos', false);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', true);
  }
}
</script>
<style>
.container-fluid {
    /*background-size: cover;
    background: url(../assets/images/background-pattern01-short.png);*/
}
</style>
<style scoped>
.blanco {
    background: #FFF;
}
.contenido {
    min-height: 500px;
}
.gris {
    background: #F2F2F2;
    border-bottom: 8px solid #000;
    margin-top: 180px !important;
}
.triangulo {
    width: 100%;
    height: 100px;
    clip-path: polygon(50% 50px, 0% 0%, 100% 0%);
    background: #FFF;
    margin-top: 0;
    position: absolute;
    z-index: 100;
}
h3 {
    font-size: 26px;
    font-weight: 700;
}
.texto {

}
.crm-titulo {
    font-weight: 700;
    font-size: 14px;
}
.crm-subtitulo {
    font-weight: 700;
    font-size: 18px;
}
.img-crm {
    width: 125px;
}
@media only screen and (max-width: 1199px){
    .crm-titulo {
        font-weight: 700;
        font-size: 14px;
    }
    .crm-subtitulo {
        font-weight: 700;
        font-size: 17px;
    }
    .img-crm {
    }
    .triangulo {
        height: 50px;
    }
}
</style>
